module.exports = __webpack_public_path__ + "media/images/social_networks/twitter-266c71e023aacdeab0decfb6466e37db.svg";